<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M5.248,24c-0.414,0-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75h13.5c0.414,0,0.75,0.336,0.75,0.75S19.162,24,18.748,24
		H5.248z"/>
	<path d="M6.748,21c-1.241,0-2.25-1.009-2.25-2.25V12c-0.4-0.002-0.781-0.052-1.146-0.149c-1.164-0.307-2.139-1.049-2.745-2.089
		c-0.606-1.04-0.771-2.254-0.464-3.418C0.32,5.68,0.652,5.056,1.104,4.538c0.851-0.974,2.083-1.532,3.38-1.532
		c0.728,0,1.436,0.174,2.073,0.507C7.299,1.87,8.75,0.642,10.513,0.19C11,0.065,11.499,0.001,11.998,0.001
		c2.35,0,4.484,1.393,5.443,3.509c0.635-0.334,1.34-0.509,2.062-0.509c0.423,0,0.846,0.061,1.256,0.18
		c1.901,0.558,3.23,2.331,3.234,4.311c0.002,1.202-0.464,2.333-1.312,3.185c-0.848,0.852-1.978,1.322-3.18,1.324
		c0,0-0.001,0-0.001,0v6.75c0,1.241-1.009,2.25-2.25,2.25H6.748z M17.248,19.5c0.414,0,0.75-0.336,0.75-0.75v-7.608
		c0-0.233,0.105-0.449,0.289-0.592c0.13-0.102,0.294-0.158,0.46-0.158c0.062,0,0.123,0.008,0.183,0.023
		c0.196,0.049,0.396,0.078,0.597,0.086c0.776-0.002,1.524-0.316,2.09-0.883c0.566-0.568,0.876-1.322,0.875-2.124
		c-0.003-1.32-0.889-2.502-2.156-2.874c-0.272-0.079-0.552-0.12-0.833-0.12c-0.715,0-1.408,0.263-1.95,0.74
		c-0.138,0.121-0.314,0.187-0.496,0.187c-0.074,0-0.148-0.011-0.219-0.033c-0.249-0.077-0.442-0.28-0.507-0.53
		c-0.508-1.98-2.29-3.363-4.334-3.363c-0.373,0-0.747,0.047-1.112,0.141c-1.581,0.406-2.816,1.64-3.221,3.221
		c-0.066,0.254-0.254,0.452-0.504,0.53C7.088,5.416,7.014,5.428,6.939,5.428c-0.182,0-0.357-0.066-0.494-0.185
		c-0.543-0.474-1.24-0.736-1.962-0.736c-0.864,0-1.684,0.371-2.25,1.019C1.932,5.87,1.711,6.285,1.595,6.727
		C1.39,7.504,1.5,8.313,1.904,9.007c0.404,0.694,1.055,1.189,1.831,1.394c0.249,0.066,0.506,0.099,0.764,0.099
		c0.173-0.007,0.374-0.037,0.565-0.085c0.061-0.015,0.122-0.023,0.184-0.023c0.166,0,0.33,0.056,0.461,0.158
		c0.184,0.143,0.289,0.359,0.289,0.592v7.608c0,0.414,0.336,0.75,0.75,0.75h2.25v-3.75c0-0.414,0.336-0.75,0.75-0.75
		s0.75,0.336,0.75,0.75v3.75h3v-3.75c0-0.414,0.336-0.75,0.75-0.75s0.75,0.336,0.75,0.75v3.75H17.248z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'chef-gear-hat',
    },
    name: {
      type: String,
      required: false,
      default: 'ChefGearHat',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>